import { render, staticRenderFns } from "./ExpansiveListItem.vue?vue&type=template&id=33fb868a&scoped=true&"
import script from "./ExpansiveListItem.vue?vue&type=script&lang=ts&"
export * from "./ExpansiveListItem.vue?vue&type=script&lang=ts&"
import style0 from "./ExpansiveListItem.vue?vue&type=style&index=0&id=33fb868a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fb868a",
  null
  
)

export default component.exports